import type { UseSchemaManagerResult } from '@/features/schema/hooks/useSchemaManager'
import type { Schema } from '@/services/api/schemas'
import { EntityFormDialog } from './EntityFormDialog'
import { PatternFormDialog } from './PatternFormDialog'
import { RelationFormDialog } from './RelationFormDialog'

export function SchemaElementDialogs({
  sm,
  schema,
}: {
  sm: UseSchemaManagerResult
  schema: Schema | null
}) {
  return (
    <>
      {' '}
      <EntityFormDialog
        open={sm.entityDialogOpen}
        onOpenChange={sm.setEntityDialogOpen}
        isEditing={!!sm.editingEntity}
        form={sm.entityForm}
        onFormChange={sm.setEntityForm}
        saving={sm.isSavingEntity}
        onSave={sm.saveEntity}
        findings={sm.entitySaveFindings}
      />
      <RelationFormDialog
        open={sm.relationDialogOpen}
        onOpenChange={sm.setRelationDialogOpen}
        isEditing={!!sm.editingRelation}
        form={sm.relationForm}
        onFormChange={sm.setRelationForm}
        saving={sm.isSavingRelation}
        onSave={sm.saveRelation}
        findings={sm.relationSaveFindings}
      />
      <PatternFormDialog
        open={sm.patternDialogOpen}
        onOpenChange={sm.setPatternDialogOpen}
        isEditing={!!sm.editingPattern}
        form={sm.patternForm}
        onFormChange={sm.setPatternForm}
        entityTypes={schema?.entity_types ?? []}
        relationTypes={schema?.relationship_types ?? []}
        onSave={sm.savePattern}
        findings={sm.patternSaveFindings}
      />
    </>
  )
}
